import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';
import Icon from '@ui/Icon';

const StudioToolbarViewOnly = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.container}>
      <Icon type="messageSmileCircle" style={{ fontSize: 32 }} />
      <div className={classes.textContainer}>
        <Typography variant="h4" bold>
          View & collaborate
        </Typography>
        <Typography variant="pMd" color="secondary">
          Listen to clips and use the comment button to share feedback.
        </Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
    height: '70%',
    padding: theme.spacing(2),
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    gap: theme.spacing(1),
  },
}));

export default StudioToolbarViewOnly;
